import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { GameProvider } from '../context/GameContext';
import { LeaderboardProvider } from '../context/LeaderboardContext';
import { TermsAndConditions } from '../screens/TermsAndConditions';

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  min-height: -webkit-fill-available;
`;

export function CityLayout() {
  return (
    <GameProvider>
      <LeaderboardProvider>
        <Wrapper>
          <Outlet />
          <TermsAndConditions />
        </Wrapper>
      </LeaderboardProvider>
    </GameProvider>
  );
}
